import { getCurrentUser } from 'domains/current_user';
import { Navigate } from 'react-router';

const UserProvider: React.FC = () => {
  const currentUser = getCurrentUser();

  if (!currentUser) {
    return <Navigate to="/signIn" />;
  }

  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <></>
  );
};

export default UserProvider;
